export default "__VITE_ASSET__DRxIMjc9__"